module.exports = __webpack_public_path__ + "static/img/nationstar.a2d902f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/thumbs/nationstar.jpg
// module id = 36
// module chunks = 1